import { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import paths from "../../utils/paths";
import axios from "axios";
import { RESET_PASSWORD } from "../../utils/apiConstants";
import { toast } from "../../utils/ToastNotification";

export default function ResetPassword() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({
    password: "",
    conPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const validatePassWord = () => {
    const errors = {};

    if (password.length < 8) {
      errors.password = "Password must be at least 8 characters";
    } else if (!/[A-Z]/.test(password)) {
      errors.password = "Password must contain at least one uppercase letter";
    } else if (!/[a-z]/.test(password)) {
      errors.password = "Password must contain at least one lowercase letter";
    } else if (!/[0-9]/.test(password)) {
      errors.password = "Password must contain at least one number";
    } else if (!/[^A-Za-z0-9]/.test(password)) {
      errors.password = "Password must contain at least one special character";
    }

    if (password !== confirmPassword) {
      errors.conPassword = "Passwords do not match";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validatePassWord()) return;
    try {
      setLoading(true);
      await axios.post(process.env.REACT_APP_API_BASE_URL + RESET_PASSWORD, {
        newPassword: password,
        token,
      });
      toast.success("password changed successfully");
      navigate(paths.Root);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong, Please try after some time!"
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        p: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 540,
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          p: 4,
        }}
      >
        <CardContent>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            className="txt-black fw-bold"
          >
            Reset Password
          </Typography>
          <Typography variant="body3" color="text.secondary">
            Please enter your new password below.
          </Typography>
          <Grid container spacing={3} mt={2}>
            <Grid size={12} className="d-flex flex-column gap-3">
              <div className="d-flex flex-column align-items-start">
                <TextField
                  type="password"
                  label="Enter Password"
                  variant="standard"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
                <span className="text-danger">{errors.password}</span>
              </div>
              <div className="d-flex flex-column align-items-start">
                <TextField
                  type="password"
                  label="Enter Confirm password"
                  variant="standard"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                  }}
                />
                <span className="text-danger">{errors.conPassword}</span>
              </div>
            </Grid>
            <Grid size={12}>
              {loading ? (
                <Button
                  variant="contained"
                  className="gradientButton rounded"
                  sx={{ textTransform: "none", borderRadius: 2 }}
                >
                  Loading...
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className="gradientButton rounded"
                  sx={{ textTransform: "none", borderRadius: 2 }}
                  onClick={handleSubmit}
                >
                  Reset password
                </Button>
              )}
            </Grid>
          </Grid>
          <Divider variant="middle" className="my-4 " />
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="body2" color="text.secondary">
              Remembered your password?{" "}
              <NavLink to={paths.Root} underline="hover" className="txt-purple">
                Sign in
              </NavLink>
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
